module.exports = __webpack_public_path__ + "sbxz-icon.png?cd691e42070969f5424896fb57e8a339";


//////////////////
// WEBPACK FOOTER
// ./static/assets/sbxz-icon.png
// module id = 43
// module chunks = 0